/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
import app from 'flarum/forum/app';
import { slug } from '../../common';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.facade_manager`;

export default class FacadeManagerHero extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		return (
			<div className="FacadeManagerHero Hero IndexPageHero">
				<div className="container">
					<div className="containerNarrow">
						<h2 className="Hero-title">{t(`${prfx}.title`)}</h2>
						<div className="IndexPageHero-controls">
							<LinkButton
								icon="far fa-edit"
								className="Button Button--primary IndexPage-newDiscussion NewFacadeLink"
								itemClassName="App-primaryControl"
								href={app.route('compose-banner')}
							>
								{t(`${prfx}.new_item`)}
							</LinkButton>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
